import { render, staticRenderFns } from "./SuspiciousProtocolsDetails.vue?vue&type=template&id=23aeea1e"
import script from "./SuspiciousProtocolsDetails.vue?vue&type=script&lang=js"
export * from "./SuspiciousProtocolsDetails.vue?vue&type=script&lang=js"
import style0 from "./SuspiciousProtocolsDetails.vue?vue&type=style&index=0&id=23aeea1e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23aeea1e')) {
      api.createRecord('23aeea1e', component.options)
    } else {
      api.reload('23aeea1e', component.options)
    }
    module.hot.accept("./SuspiciousProtocolsDetails.vue?vue&type=template&id=23aeea1e", function () {
      api.rerender('23aeea1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SuspiciousProtocolsDetails.vue"
export default component.exports